import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/et';
import 'dayjs/locale/ru';
import weekday from 'dayjs/plugin/weekday';
import { TFunction } from 'i18next';

import { Locale } from '@/hooks/use-locale';

dayjs.extend(weekday);

export const parseDischargeFrequencyText = (rule: string, locale: Locale, t: TFunction<string, undefined>): string => {
  if (!rule) {
    return t('onRequest');
  }

  if (/eri/i.test(rule)) {
    return t('specialSchedule');
  }

  dayjs.locale(locale);

  const specialCases: Record<string, string> = {
    '0': t('onRequest'),
  };

  if (specialCases[rule]) {
    return specialCases[rule];
  }

  const multiDayMatch = rule.match(/^([A-Z](,[A-Z])*)$/i);
  const periodicMatch = rule.match(/^([A-Z])\/(\d+)$/i);

  if (multiDayMatch) {
    const days = multiDayMatch[1].split(',').map((day) => {
      const dayOfWeek = day.trim().toUpperCase();
      switch (dayOfWeek) {
        case 'E':
          return dayjs().locale(locale).weekday(0).format('dd'); // Mon
        case 'T':
          return dayjs().locale(locale).weekday(1).format('dd'); // Tue
        case 'K':
          return dayjs().locale(locale).weekday(2).format('dd'); // Wed
        case 'N':
          return dayjs().locale(locale).weekday(3).format('dd'); // Thu
        case 'R':
          return dayjs().locale(locale).weekday(4).format('dd'); // Fri
        case 'L':
          return dayjs().locale(locale).weekday(5).format('dd'); // Sat
        case 'P':
          return dayjs().locale(locale).weekday(6).format('dd'); // Sun
        default:
          return '---';
      }
    });
    return t('daysLabel', { days: days.join(', ') });
  }

  if (periodicMatch) {
    const day = periodicMatch[1].toUpperCase();
    const frequency = parseInt(periodicMatch[2], 10);
    const totalDays = frequency * 7;
    const dayName = dayjs().locale(locale).weekday(['E', 'T', 'K', 'N', 'R', 'L', 'P'].indexOf(day)).format('dd') || '???';
    return t('periodic', { frequency, day: dayName, totalDays });
  }

  return t('onRequest');
};
